// extracted by mini-css-extract-plugin
module.exports = {"base":"DataQuality_base__3zpTc","cell":"DataQuality_cell__1FSeo"};